import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useBanner from "../../../../hooks/useBanner";

export default function AddLocationModal({
  setOpenAddLocation,
  onTrigger,
  locationData,
}) {
  const [formData, setFormData] = useState({
    location: locationData?.location || "",
    product: locationData?.product || "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { saveLocation } = useBanner();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.location)
      return setErrors({ location: "locaiton title is required" });
    if (!formData.product) return setErrors({ product: "Select a product" });

    setLoading(true);
    try {
      if (locationData) {
        await saveLocation(setLoading, formData, locationData._id, "PATCH");
      } else {
        await saveLocation(setLoading, formData);
      }
      void onTrigger();
      setOpenAddLocation(false);
      setLoading(false);
    } catch (error) {
      console.error("Failed to submit location:", error);
      setErrors({ submit: "Failed to save location. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div
        className="bg-white w-full max-w-lg relative max-h-[94vh] overflow-y-auto rounded-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center bg-blue-600 text-white px-6 py-4 sticky top-0">
          <h2 className="text-lg font-semibold text-white">
            {locationData ? "Update location" : "Create a new Location"}
          </h2>
          <CloseIcon
            onClick={() => setOpenAddLocation(false)}
            className="cursor-pointer"
          />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4 px-6 py-6">
          {/* Title */}
          <div className="flex flex-col">
            <label className="text-sm mb-1">Location title</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Enter title"
              className={`w-full border ${
                errors.location ? "border-red-500" : "border-gray-300"
              } rounded-md px-4 py-2 focus:outline-none`}
            />
            {errors.location && (
              <p className="text-red-500 text-xs mt-1">{errors.location}</p>
            )}
          </div>

          {/* Product Dropdown */}
          <div className="flex flex-col">
            <label className="text-sm mb-1">Product</label>
            <select
              name="product"
              value={formData.product}
              onChange={handleInputChange}
              className={`w-full border ${
                errors.product ? "border-red-500" : "border-gray-300"
              } rounded-md px-4 py-2 focus:outline-none`}
            >
              <option value="">Select a product</option>
              <option value="flight">Flight</option>
              <option value="hotel">Hotel</option>
              <option value="tour">Tour</option>
            </select>
            {errors.product && (
              <p className="text-red-500 text-xs mt-1">{errors.product}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="grid grid-cols-4 gap-4 mt-4">
            <button
              type="button"
              onClick={() => setOpenAddLocation(false)}
              className="bg-white border font-medium border-gray-200 rounded-md text-gray-700 col-span-1 py-3 flex justify-center items-center hover:bg-gray-100"
            >
              Close
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-600 rounded-md font-bold text-white py-3 col-span-3 flex justify-center items-center hover:bg-blue-700"
            >
              {loading
                ? locationData
                  ? "Updating..."
                  : "Creating..."
                : locationData
                ? "Update"
                : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
